import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import "./Header.css";

const Header = ({ language, setLanguage }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const showHeader = ["/maqs/english", "/maqs/hindi"].includes(location.pathname);

  // Initialize language from localStorage on first render
  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      setLanguage(savedLanguage);
    }
  }, []); // Run only on mount

  // Update language when URL changes
  useEffect(() => {
    if (location.pathname === "/maqs/hindi") {
      setLanguage("hindi");
    } else {
      setLanguage("english");
    }
  }, [location.pathname, setLanguage]);

  // Sync language to localStorage whenever it updates
  useEffect(() => {
    if (language) {
      localStorage.setItem("language", language);
    }
  }, [language]);

  // Scroll to top when route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]); // Run on route change

  const handleChange = (event) => {
    const selectedLanguage = event.target.value.toLowerCase();
    setLanguage(selectedLanguage);
    navigate(`/maqs/${selectedLanguage}`, { replace: true }); // Prevents adding history entry
  };

  const handleBack = () => {
    navigate(-1);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 5); // Small delay to ensure page transition completes
  };

  return (
    <>
      <button className="back-button" onClick={handleBack}>
        <IoArrowBack size={24} />
      </button>
      {showHeader && (
        <header className="header">
          <nav className="header-nav">
            <select className="language-dropdown" onChange={handleChange} value={language}>
              <option value="english">English</option>
              <option value="hindi">हिन्दी</option>
            </select>
          </nav>
        </header>
      )}
    </>
  );
};

export default Header;